import { ThemeService } from "../services/themeService";

/**
 * Get the initial background color for the app based on domain or environment
 */
export const getInitialBackgroundColor = (): string => {
  // Check if we have an environment variable override
  if (
    typeof window !== "undefined" &&
    window.environmentSettings?.initialBackgroundColor
  ) {
    return window.environmentSettings.initialBackgroundColor as string;
  }

  // Check theme from localStorage first
  if (typeof window !== "undefined") {
    const themeService = ThemeService.getInstance();
    const storedTheme = themeService.getStoredTheme();

    if (storedTheme) {
      // Use theme from localStorage
      return storedTheme === "light" ? "white" : "black";
    }

    // Fallback to domain-based logic if no theme is stored
    const hostname = window.location.hostname;
    if (hostname.includes("illio")) {
      return "white";
    }

    return "black";
  }

  // Default fallback
  return "black";
};

/**
 * Apply the initial background color to the document body
 */
export const applyInitialBackgroundColor = (): void => {
  if (typeof document !== "undefined") {
    const backgroundColor = getInitialBackgroundColor();
    document.body.style.backgroundColor = backgroundColor;
    document.documentElement.style.backgroundColor = backgroundColor;
  }
};
